import React from 'react';
import LogoTaaptSVG from '../Imagenes/Taapt.png';
import './Logo.css';

const Logo: React.FC = () => {
  return (
    <div className='Logo'>
      <a href='/'> 
        <img src={LogoTaaptSVG} alt="Taapt Logo" />
      </a>
    </div>
  );
};

export default Logo;
